import { Expose } from 'class-transformer';
import { Model } from '@shared-features/models/model';

export class ColumnOptionsStateKey extends Model {
  @Expose()
  key: string;
  @Expose()
  order: number;
}
